import { reactive } from 'vue';
import {
    ServerContextModel,
} from '@/types/B2BcontentServerContract';

export const WINDOW_SERVER_CONTEXT_PROPERTY = '$$serverContext$$';

class ServerContextStore {
    state: ServerContextModel = reactive(Object.freeze({
        ...window[WINDOW_SERVER_CONTEXT_PROPERTY],
    }));

    constructor() {
        if (!window[WINDOW_SERVER_CONTEXT_PROPERTY]) {
            throw new Error(`### window.${WINDOW_SERVER_CONTEXT_PROPERTY} object should exist ###`);
        }
    }

    public get settings() {
        return this.state;
    }

    get recaptchaKey(): string {
        return this.state?.recaptcha.siteKey ?? '';
    }

    public get apiEndPoint(): string {
        return this.state?.apiEndPoint ?? '';
    }

    public get moduleConfiguratorBaseUrl(): string {
        return this.state?.moduleConfigurator?.baseUrl ?? '';
    }

    public get moduleConfiguratorJsBundleUrl(): string {
        return `${this.state?.moduleConfigurator?.baseUrl ?? ''}/${this.state?.moduleConfigurator?.jsBundlePath ?? ''}`;
    }
}

export default new ServerContextStore();
